export function combineClass(...text: string[]): string {
	return text.filter((item) => item).join(' ');
}
